<template>
  <div id="app" class="app">
    <router-view></router-view>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Cookies from 'js-cookie';
import apis from './utils/apis';

export default {
  name: 'App',
  data() {
    return {
      theme: {
        'custom-546EE7': 'theme2',
      },
    };
  },
  watch: {
    $route: function () {
      this.fixElToolTip();
    },
  },
  computed: {
    ...mapState({
      includeList: state => state.vm.includeList,
    }),
  },
  mounted() {
    this.getLoginLanguage();
    const themeColor = this.$store.state.themeColor;
    if (themeColor) {
      document.body.className = themeColor; // element框架主题
      document.body.setAttribute('data-theme', this.theme[themeColor]); // 其他样式主题
    }
  },
  methods: {
    getLoginLanguage() {
      this.$getJSON(apis.LanguageLogin, { appCode: 'isynergy_cloud', langKeyCode: 'login_bind_account,login_select_lang,login_find_password,login_login,login_notfound,login_reset_password' }).then((res) => {
        const langCode = Cookies.get('langCode') || 'CN';
        this.$i18n.mergeLocaleMessage(langCode, res.data || {});
      });
    },
    // fix：el-tooltip
    // bug描述： 点击跳转新页面时，el-tooltip如果是显示的话，不会消失
    fixElToolTip() {
      // el-tooltip__popper
      const els = document.querySelectorAll('.el-tooltip__popper');
      [...els].forEach((el) => {
        el.style.display = 'none';
      });
    },
  },
};
</script>

<style lang="scss">
@import './style/base.css';
/*@import "./style/iconfont.css";*/
</style>
